import axios from "axios";
import config from "../config";

const haklaiAxios = axios.create();

const haklaiThirdPartyService = {
  convertDollarCurrency: function (amount, date) {
    return new Promise((resolve) => {
      if (!date) return resolve({ err: "Missing conversion date" });
      const token = localStorage.getItem("token");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const query = `amount=${encodeURIComponent(String(amount))}&date=${encodeURIComponent(String(date))}`;
      haklaiAxios
        .get(`${config.getHaklaiDollarCurrencyEndpoint}?${query}`, { headers, timeout: 10000 })
        .then((serverRes) => {
          if (serverRes.data?.needsLogin) {
            const stationName = localStorage.getItem("stationName");
            localStorage.clear();
            localStorage.setItem("stationName", stationName);
            document.location.href = "/sessions/login";
            return resolve({ err: "needsLogin" });
          }
          if (serverRes.data) return resolve(serverRes.data);
          resolve({ err: "Problem with the request" });
        })
        .catch((error) => {
          resolve({ err: error?.message || "Problem with the request" });
        });
    });
  }
};

export default haklaiThirdPartyService;
